import { groupsTranslate } from './Locale/Groups/_index';
import { env } from '@/env';

export interface IGroupsTemplate {
  images: {
    emptyState: string;
    peopleGroup: string;
    peopleClock: string;
  };
  locale: typeof groupsTranslate;
}

const SonarGroups: IGroupsTemplate = {
  images: {
    emptyState: `${env.VITE_CDN_URL}/Sonarprint/sonar-print/groups/img-empty-groups.svg`,
    peopleGroup: `${env.VITE_CDN_URL}/Sonarprint/sonar-print/groups/people-group.svg`,
    peopleClock: `${env.VITE_CDN_URL}/Sonarprint/sonar-print/groups/people-clock.svg`,
  },
  locale: groupsTranslate,
};

export { SonarGroups };
